<template>
  <v-container v-if="currentUser">
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("nav.user.profile") }}
      </v-toolbar-title>
    </v-app-bar>

    <v-row>
      <v-col v-if="currentUser.state === 'PENDING' && !currentUser.lastname" cols="12">
        <v-card>
          <v-card-title>
            {{ $t("user.profile.pending.title") }}
          </v-card-title>

          <v-card-text>
            <Markdown :value="$t('user.profile.pending.description')" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col v-if="currentUser.state === 'REJECTED'" cols="12">
        <v-card>
          <v-card-title>
            {{ $t("user.profile.rejected.title") }}
          </v-card-title>

          <v-card-text>
            {{ $t("user.profile.rejected.description") }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <ProfileForm />
      </v-col>

      <v-col v-if="currentUser.state === 'PENDING' && currentUser.lastname" cols="12">
        <v-card color="green" dark>
          <v-card-title>
            {{ $t("user.profile.review.title") }}
          </v-card-title>

          <v-card-text>
            <Markdown :value="$t('user.profile.review.description')" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProfileForm from "@/components/User/ProfileForm";
import ProfileQuery from "@/gql/queries/ProfileQuery.gql";

export default {
  components: {
    ProfileForm,
  },

  data() {
    return {
      currentUser: null,
    };
  },

  apollo: {
    currentUser: {
      query: ProfileQuery,
    },
  },
};
</script>
